import {
  GET_ALL_ROLES,
  GET_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  GET_ROLES_STRUCTURE,
  GET_USER_ROLE_PERMISSIONS,
  INITIAL_DATA,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_ALL_ROLES: {
      return {
        ...state,
        getRoleList: action.payload,
      }
    }
    case GET_ROLE: {
      return {
        ...state,
        getRoleData: action.payload,
      }
    }
    case UPDATE_ROLE: {
      return {
        ...state,
        getRoleData: action.payload,
      }
    }
    case DELETE_ROLE: {
      let list = [...(state.getRoleList || [])]
      if (action.payload) {
        list = list.filter(item => item.id !== Number(action.payload))
      }
      return {
        ...state,
        getRoleList: list,
      }
    }

    case GET_ROLES_STRUCTURE:
      return {...state, rolesStructure: action.payload || {}}

    case GET_USER_ROLE_PERMISSIONS:
      return {
        ...state,
        userPermissions: action.payload || {},
      }

    case INITIAL_DATA: {
      return {
        ...state,
        userPermissions: action.payload.permissions || {},
      }
    }

    default:
      return state
  }
}
